module.exports = window.__lib.React;